<template>
  <div v-masonry transition-duration="0.3s">
    <div class="masonry-grid" v-masonry origin-left="false" transition-duration="1s" item-selector=".col-m-4">
      <div v-masonry-tile class="col-m-4 col-s-6" v-for="(block, index) in projects" :key="index">
        <ProductCard :block="block" />
      </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import { VueMasonryPlugin } from 'vue-masonry';

import ProductCard from '@/components/ProductCard.vue'

Vue.use(VueMasonryPlugin)

const name = 'Portfolio'

function data() {
  return {
    blocks: [{
      title: 'ПО для интерактивного киоска',
      description: 'Сеть киосков для музея Стадиона Калининград',
      src: require('@/assets/img/stadium/thumb.jpg'),
      path: '/portfolio/stadium',
      slug: 'stadium'
    }, {
      title: 'Rebalance.Website',
      description: 'Сервис для удобной балансировки инвестиционного портфеля',
      src: require('@/assets/img/rebalancer/thumb.jpg'),
      path: '/portfolio/rebalancer',
      slug: 'rebalancer'
    }, {
      title: 'Webshow для CarementorAI',
      description: 'Сервис онлайн-диагностики радиологических исследований на базе AI',
      src: require('@/assets/img/webshow/thumb.jpg'),
      path: '/portfolio/webshow',
      slug: 'webshow'
    }, {
      title: 'Сеть онлайн-казино',
      description: 'Сеть легальных онлайн-казино в США и Канаде',
      src: require('@/assets/img/payday/thumb.jpg'),
      path: '/portfolio/payday',
      slug: 'payday'
    }, {
      title: 'Парсер Avito',
      description: 'Бот для автоматического парсинга сервиса Авито',
      src: require('@/assets/img/avito/thumb.jpg'),
      path: '/portfolio/avito',
      slug: 'avito'
    }, {
      title: 'JobBoo - приложение для клиентов',
      description: 'iOS и Android приложения для быстрого найма работников для уборки или ремонта',
      src: require('@/assets/img/jobbooclient/thumb.jpg'),
      path: '/portfolio/jobbooclient',
      slug: 'jobbooclient'
    }, {
      title: 'Посадочная страница для приложения',
      description: 'Посадочная страница для клиентского приложения стартапа Jobboo',
      src: require('@/assets/img/jobbooclientlp/thumb.jpg'),
      path: '/portfolio/jobbooclientlp',
      slug: 'jobbooclientlp'
    }, {
      title: 'Jobboo - приложение для работников',
      description: 'iOS и Android приложения для распределения заказов между работниками',
      src: require('@/assets/img/jobbooworker/thumb.jpg'),
      path: '/portfolio/jobbooworker',
      slug: 'jobbooworker'
    }, {
      title: 'Посадочная страница для приложения',
      description: 'Посадочная страница приложения для работников стартапа Jobboo',
      src: require('@/assets/img/jobbooworkerlp/thumb.jpg'),
      path: '/portfolio/jobbooworkerlp',
      slug: 'jobbooworkerlp'
    }, {
      title: 'Интернет-магазин мотозапчастей',
      description: 'Cпециализированный интернет-магазин запчастей на мотоциклы марки Ducati',
      src: require('@/assets/img/motofreak/thumb.jpg'),
      path: '/portfolio/motofreak',
      slug: 'motofreak'
    }, {
      title: 'Веб-сайт студии дизайна интерьеров',
      description: 'Дизайн для создателей интерьеров с акцентом на фото-контент',
      src: require('@/assets/img/kitchenroom/thumb.jpg'),
      path: '/portfolio/kitchenroom',
      slug: 'kitchenroom'
    }, {
      title: 'Landing page для инстаграм-бота',
      description: 'Базовая продающая страница для SaaS-сервиса по автоматическо раскрутке в инстаграм',
      src: require('@/assets/img/savagelp/thumb.jpg'),
      path: '/portfolio/savagelp',
      slug: 'savagelp'
    }, {
      title: 'SaaS-сервис по автоматизации раскрутки в Instagram',
      description: 'Клиентский дашборд для управления аккаунтами, настройками бота и сбора статистики',
      src: require('@/assets/img/savage/thumb.jpg'),
      path: '/portfolio/savage',
      slug: 'savage'
    }, {
      title: 'Веб-сайт для Спортзала',
      description: 'Сайт фитнес-клуба с личным кабинетом для управления абонементом.',
      src: require('@/assets/img/sportzal/thumb.jpg'),
      path: '/portfolio/sportzal',
      slug: 'sportzal'
    }, {
      title: 'Веб-сайт для салона дверей',
      description: 'Сайт салона по продаже дверей под заказ.',
      src: require('@/assets/img/pulsar/thumb.jpg'),
      path: '/portfolio/pulsar',
      slug: 'pulsar'
    }]
  }
}

const props = {
  mode: {
    type: String,
    default: 'full'
  }
}

const computed = {
  projects() {
    if (this.mode == 'sample') {
      return this.blocks.slice(0, 8);
    } else if (this.$route.meta.productSlug) {
      return this.blocks.filter(item => {
        return item.slug !== this.$route.meta.productSlug
      }).slice(0, 3)
    } else {
      return this.blocks
    }
  }
}

export default {
  name,
  data,
  props,
  computed,
  components: {
    ProductCard
  }
}

</script>
